<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t('List-Tickets-Without-Current-Processes') }} </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn @click="sendCurrent()" flat>
              <span class="hidden-sm-and-down"> {{ $t('Current-Process') }}</span>
              <v-icon right dark>add_box</v-icon>
            </v-btn>
          </v-toolbar>
        </v-flex>
      </v-layout>
    </v-card>

    <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex pa-2 xs12 sm12 md12>
          <v-card flat class="pa-1">
            <v-layout row wrap>
              <v-flex xs12 sm6 pt-2 md2>
                <tarihcomp
                  :etiket="$t('Starting-Date')"
                  :detaygizle="false"
                  :rules="[(v) => !!v || $t('Please-select-a-date')]"
                  v-bind:defaultvalue="'ok'"
                  v-model="ListParams.BaslangicTarihi"
                ></tarihcomp>
              </v-flex>

              <v-flex xs12 pt-2 sm6 md2>
                <tarihcomp
                  :etiket="$t('Finishing-Date')"
                  :detaygizle="false"
                  :rules="[(v) => !!v || $t('Please-select-a-date')]"
                  v-bind:defaultvalue="'ok'"
                  v-model="ListParams.BitisTarihi"
                ></tarihcomp>
              </v-flex>

              <v-flex pt-2>
                <v-layout align-center="">
                  <div v-if="load1">
                    <v-btn
                      color="info"
                      @click="getList(1, kayitadet, siralamatipi, true)"
                      fab
                      small=""
                      dark
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <v-layout row="" wrap>
      <v-flex v-show="kayitvarmi" xs12 sm12 md12>
        <v-card flat="" color="grey lighten-5">
          <v-flex xs12 sm12 md12>
            <v-layout row wrap>
              <v-flex xs12 sm2 md2>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-layout v-if="kayitvarmi" justify-center="" align-center>
                      <v-checkbox
                        v-model="tumunuseckaldir"
                        :label="$t('Choose-All')"
                      ></v-checkbox>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>
              </v-flex>

              <v-flex xs12 sm7 md7>
                <v-layout align-center="" justify-center fill-height="">
                  <div class="font-weight-large grey--text body-1">
                    <span class="red--text"> ({{ sayfalama }}.Sayfa)</span> -
                    {{$t('Total')}} {{ totalcount }} {{$t('number-records-listed')}}.
                  </div>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md2>
                <v-select
                  hide-details=""
                  :items="siralamatipiitems"
                  color="grey darken-1"
                  v-model="siralamatipi"
                  item-text="text"
                  item-value="value"
                  :label="$t('Sort-By')"
                >
                </v-select>
              </v-flex>
              <v-flex v-show="kayitvarmi" xs12 sm12 md1>
                <v-select
                  hide-details=""
                  :items="kayitsayisi"
                  color="grey darken-1"
                  v-model="kayitadet"
                  item-text="text"
                  item-value="value"
                  :label="$t('Show')"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex
            pa-2
            v-for="item in ticketList"
            v-bind:key="item.id"
            xs12
            sm12
            md12
          >
            <v-card width="100%" class="my-2">
              <v-list>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-card flat class="black--text">
                      <v-card flat="">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-list-tile class="align-center">
                              <v-list-tile-content>
                                <v-layout class="pb-3">
                                  <v-checkbox
                                    hide-details=""
                                    v-model="secilenkayitlar"
                                    :value="item.itemcheck"
                                  >
                                  </v-checkbox>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>

                            <v-flex sm12 md1>
                              <v-card flat="">
                                <v-list-tile>
                                  <v-list-tile-content>
                                    <v-img
                                      :src="
                                        getImgUrl(
                                          item.BiletBilgileri.HavayoluKodu
                                        )
                                      "
                                      height="60%"
                                      width="60%"
                                      contain
                                    >
                                    </v-img>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-card>
                            </v-flex>

                            <v-flex xs12 sm4 md3>
                              <v-layout
                                align-start
                                justify-start
                                row
                                fill-height
                              >
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title>
                                        &nbsp;<span
                                          class="grey-text--primary title"
                                        >
                                          {{ item.BiletBilgileri.HavayoluKodu }}
                                          -
                                          {{ item.BiletBilgileri.BiletNo }}
                                          -
                                          {{ item.BiletBilgileri.UcusTipi }}
                                        </span>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm4 md2>
                              <v-layout
                                align-start
                                justify-start
                                row
                                fill-height
                              >
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout
                                        row
                                        wrap
                                        align-center=""
                                        justify-center
                                      >
                                        <v-list-tile-title>
                                          <div
                                            class="
                                              font-weight-large
                                              red--text
                                              title
                                            "
                                          >
                                            {{
                                              item.BiletBilgileri.SatisTarihi
                                                | dateformat
                                            }}
                                          </div>
                                        </v-list-tile-title>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>

                            <v-flex class="hidden-md-and-up" xs2 sm2 md3>
                            </v-flex>

                            <v-flex xs12 sm4 md2>
                              <v-layout>
                                <v-flex xs12 sm6 md6>
                                  <v-layout
                                    align-start=""
                                    justify-start
                                    fill-height
                                  >
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-list-tile-sub-title>
                                            <div class="font-weight body-2">
                                              {{ $t('Form-No') }} :
                                            </div>
                                          </v-list-tile-sub-title>
                                          <v-list-tile-sub-title>
                                            <div class="font-weight body-2">
                                              {{ $t('Customer-Code') }} :
                                            </div>
                                          </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm6 md6>
                                  <v-layout row justify-end="" fill-height>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-list-tile-sub-title>
                                            <v-layout
                                              align-center=""
                                              justify-end
                                            >
                                              <div class="font-weight body-2">
                                                {{ item.BiletBilgileri.FormNo }}
                                              </div>
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                          <v-list-tile-sub-title>
                                            <v-layout
                                              align-center=""
                                              justify-end=""
                                            >
                                              <div class="font-weight body-2">
                                                {{
                                                  item.BiletBilgileri
                                                    .MusteriKodu
                                                }}
                                              </div>
                                            </v-layout>
                                          </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs2 sm2 md2> </v-flex>

                            <v-flex xs12 sm4 md1>
                              <v-layout
                                row
                                align-center
                                justify-center=""
                                fill-height=""
                              >
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content>
                                      <v-layout row wrap justify-center="">
                                        <v-list-tile-title>
                                          <v-layout row wrap justify-center="">
                                            {{ $t("Net-Amount") }}
                                          </v-layout>
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title>
                                          <v-layout row wrap justify-center="">
                                            <div class="red--text title">
                                              {{
                                                item.BiletBilgileri.NetTutar
                                                  | moneyformat
                                              }}{{ getparabirimi() }}
                                            </div>
                                          </v-layout>
                                        </v-list-tile-sub-title>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-list>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>

    <v-container v-if="kayitvarmi" fluid="">
      <v-flex xs12 sm12 md12>
        <v-layout row fill-height="" justify-center>
          <v-pagination v-model="sayfalama" :length="pagenumber"></v-pagination>
        </v-layout>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "@/components/app/customcomp/tarihim";
import auth from "@/api/auth.js";
import logoo from "@/assets/control.js";

export default {
  data() {
    return {
      secilenkayitlar: [],
      siralamatipiitems: [
        {
          text: this.$t('Date-Ascending'),
          value: "RefundDate",
        },
        {
          text: this.$t('Date-Descending'),
          value: "RefundDateDesc",
        },
        {
          text: this.$t('Current-Ascending'),
          value: "RefundCurrentCode",
        },
        {
          text: this.$t('Current-Descending'),
          value: "RefundCurrentCodeDesc",
        },
        {
          text: this.$t('Invoice-Date-Ascending'),
          value: "RefundInvoiceDate",
        },
        {
          text: this.$t('Invoice-Date-Descending'),
          value: "RefundInvoiceDateDesc",
        },
        {
          text: this.$t('Price-Ascending'),
          value: "RefundAmount",
        },
        {
          text: this.$t('Price-Descending'),
          value: "RefundAmountDesc",
        },
        {
          text: this.$t('Returns-Ticket-No-Ascending'),
          value: "RefundTicket",
        },
        {
          text: this.$t('Returns-Ticket No-Descending'),
          value: "RefundTicketDesc",
        },
        {
          text: this.$t('Receipt-No-Ascending'),
          value: "RefundReceipt",
        },
        {
          text: this.$t('Receipt-No-Descending'),
          value: "RefundReceiptDesc",
        },
      ],
      kayitsayisivmodel: 50,
      kayitsayisi: [
        {
          text: "50",
          value: 50,
        },
        {
          text: "100",
          value: 100,
        },
      ],
      totalcount: 0,
      sayfalama: 1,
      pagenumber: 1,
      tumunuseckaldir: false,
      ListParams: {
        HavaYoluKodu: null,
        BiletNo: null,
        CariKodu: null,
        FormNo: null,
        SirketKodu: null,
        BaslangicTarihi: null,
        BitisTarihi: null,
        TextSearch: null,
        Filtreler: {
          CariKod: null,
          Havayollari: [],
          Parkurlar: [],
          HatTipi: [],
          BiletTipi: null,
          Ucus1: null,
          Ucus2: null,
          KesenKisi: null,
          PosKod: null,
          KrediKartNo: null,
          GiderPusulasi: 0,
          AcentaFatNo: 0,
          IadeFatura: false,
          DekontBas: false,
          FaturaStatus: 0,
          GeciciCari: 0,
          BorcluListShow: false,
          FaturaSeri: null,
          FaturaNo: 0,
          FaturaTarihi: null,
          BaslangicTutar: 0.0,
          BitisTutar: 0.0,
          TutarTip: 0,
          SifirTutarGosterme: false,
        },
        Paging: {
          SayfaNo: 1,
          VeriAdet: 50,
          SiralamaTip: "RefundDate",
        },
      },
      valid: true,
      kayitadet: 50,
      siralamatipi: "RefundDate",
      load1: true,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      kayitvarmi: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      ticketList: [],
    };
  },
  methods: {
    sendCurrent() {
      //var params = this.secilenkayitlar;
      this.loadingvmodel = true;

      var params = [];
      if (this.tumunuseckaldir) {
        this.ticketList.forEach((element) => {
          params.push(element.BiletBilgileri);
        });
      } else {
        this.secilenkayitlar.forEach((element) => {
          var i = this.ticketList.findIndex(
            (k) => k.BiletBilgileri.BiletNo == element.BiletNo
          );
        params.push(this.ticketList[i].BiletBilgileri);
        });
      }


      this.$http
        .post(auth.API_URL + "api/Ticket/TicketNoCurrentReSave", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            if (response.body.Status) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
              this.getList(1, this.kayitadet, this.siralamatipi, false);
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
            }
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    getImgUrl(img) {
      return logoo.logoControl(img);
    },
    getList(sayfano, adet, siralatip, arama) {
      if (this.$refs.formgunluksatis.validate()) {
        this.loadingvmodel = true;

        if (arama == true) {
          this.secilenkayitlar = [];
          this.tumunuseckaldir = false;
        }

        this.kayitvarmi = false;
        var bastarih = new Date(this.ListParams.BaslangicTarihi);
        var bittarih = new Date(this.ListParams.BitisTarihi);

        if (bastarih <= bittarih) {
          this.load1 = false;
          this.iadelist = [];

          var credentials = JSON.parse(
            window.localStorage.getItem("credentials")
          );
          this.ListParams.SirketKodu = credentials.SirketKodu;
          this.ListParams.Paging.SayfaNo = sayfano;
          this.ListParams.Paging.VeriAdet = adet;
          this.ListParams.Paging.SiralamaTip = siralatip;

          var params = this.ListParams;

          this.$http
            .post(auth.API_URL + "api/Ticket/TicketListNoCurrent", params, {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader(),
              },
            })
            .then(
              (response) => {
                if (response.body.length > 0) {
                  this.kayitvarmi = true;
                  this.loadingvmodel = false;
                  var credentials = JSON.parse(
                    window.localStorage.getItem("credentials")
                  );

                  var yenilist = [];
                  response.body.forEach((element) => {
                    var itemdegeri = {
                      SirketKodu: credentials.SirketKodu,
                      HavaYoluKodu: element.HavaYoluKodu,
                      FormNo: element.Formno,
                      BiletNo: element.BiletNo,
                      Sirano: element.Sirano,
                      IadeTarihi: element.IadeTarihi,
                      BiletShow: true,
                    };

                    var a = {
                      BiletBilgileri: element,
                      itemcheck: itemdegeri,
                    };
                    yenilist.push(a);
                  });

                  this.ticketList = yenilist;

                  this.totalcount = response.body[0].TotalCount;
                  this.pagenumber = response.body[0].TotalPage;
                  this.recordcount = response.body.length;
                } else {
                  this.kayitvarmi = false;
                  this.dekontdurum = false;
                }

                this.loadingvmodel = false;
                this.progress = false;
                this.load1 = true;
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                  this.kayitvarmi = false;
                  this.progress = false;
                  this.loadingvmodel = false;
                  this.dekontdurum = false;
                  this.load1 = true;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                  this.dekontdurum = false;
                  this.loadingvmodel = false;
                  this.kayitvarmi = false;
                  this.progress = false;
                  this.load1 = true;
                }
              }
            );
        } else {
          this.text1 = this.$t('start-date-cannot-greater-than-end-date')
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      }
    },
    getListtumu() {
      if (this.$refs.formgunluksatis.validate()) {
        this.loadingvmodel = true;
        this.secilenkayitlar = [];

        var bastarih = new Date(this.ListParams.BaslangicTarihi);
        var bittarih = new Date(this.ListParams.BitisTarihi);

        if (bastarih <= bittarih) {
          var credentials = JSON.parse(
            window.localStorage.getItem("credentials")
          );

          if (this.tumsirketler === true) {
            this.ListParams.SirketKodu = "0";
          } else {
            this.ListParams.SirketKodu = credentials.SirketKodu;
          }

          this.ListParams.Paging.SayfaNo = null;
          this.ListParams.Paging.VeriAdet = null;
          this.ListParams.Paging.SiralamaTip = this.siralamatipi;

          var params = this.ListParams;

          this.$http
            .post(auth.API_URL + "api/Ticket/TicketListNoCurrent", params, {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader(),
              },
            })
            .then(
              (response) => {
                if (response.body.length > 0) {
                  var credentials = JSON.parse(
                    window.localStorage.getItem("credentials")
                  );

                  this.secilenkayitlar = [];
                  response.body.forEach((element) => {
                    var itemdegeri = {
                      SirketKodu: credentials.SirketKodu,
                      HavaYoluKodu: element.HavaYoluKodu,
                      FormNo: element.Formno,
                      BiletNo: element.BiletNo,
                      Sirano: element.Sirano,
                      IadeTarihi: element.IadeTarihi,
                      BiletShow: true,
                    };

                    this.secilenkayitlar.push(itemdegeri);
                  });
                }
                this.loadingvmodel = false;
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                }
              }
            );
        } else {
          this.text1 = this.$t('start-date-cannot-greater-than-end-date')
          this.snackbar = true;
          this.loadingvmodel = false;
        }
      }
    },
  },
  watch: {
    sayfalama(value) {
      this.getList(value, this.kayitadet, this.siralamatipi, false);
    },
    tumunuseckaldir: function (value) {
      if (value == true) {
        this.getListtumu();
      } else {
        this.secilenkayitlar = [];
      }
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      //YETKİ OK
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>

